/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { DropdownCustomToggler, DropdownMenu3 } from "../../dropdowns";
import { getLastOrders } from "../../../_helpers/DashboardRequests";
import {
  OrderStatusCssClasses,
  OrderStatusTitles,
} from "../../../../app/modules/Sale/pages/orders-list/OrdersListUIHelpers";
import { Link } from "react-router-dom";

export function LastOrdersWidget({ className }) {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getLastOrders().then((response) => {
      setOrders(response.data.entities);
    });
  }, []);

  return (
    <>
      <div className={`card card-custom ${className}`}>
        {/* Header */}
        <div className="card-header border-0">
          <h3 className="card-title font-weight-bolder text-dark">
            آخرین سفارشات ثبت شده
          </h3>
        </div>

        {/* Body */}
        <div className="card-body pt-0">
          {orders.map((order) => (
            <div className="mb-6" key={order.id}>
              <div className="d-flex align-items-center flex-grow-1">
                <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
                  <div className="d-flex flex-column align-items-cente py-2 w-75">
                    <Link
                      to={`/reports/sales/${order.id}`}
                      className="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
                    >
                      {order.name}
                    </Link>

                    <span className="text-muted font-weight-bold">
                      {new Date(order.createDate).toLocaleString("fa-IR")}
                    </span>
                  </div>

                  <span
                    className={`label label-lg label-light-${
                      OrderStatusCssClasses[order.orderStatus]
                    } label-inline font-weight-bold py-4`}
                  >
                    {OrderStatusTitles[order.orderStatus]}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
